// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Details } from '@return-rabbit/nexus';
import get from 'lodash.get';

import { Text } from 'ui-components/components/text';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import { ReturnPaymentTypes } from '../../../../../../enums/return-payment-types';
import style from './styles.module.less';

const RADIO_INPUT_NAME = 'SSR_REFUND_OPTION';

export function RefundOptions() {
  const { options, selected, isLoading, isSaving, onSelectRefundMethod } = Details.useRefundInfo();

  const opmId = get(options, [ReturnPaymentTypes.OriginalPaymentMethod.key, 'id'], '');
  const opmAmount = get(options, [ReturnPaymentTypes.OriginalPaymentMethod.key, 'total_amount'], 0);
  const giftCardId = get(options, [ReturnPaymentTypes.GiftCard.key, 'id'], '');
  const giftCardAmount = get(options, [ReturnPaymentTypes.GiftCard.key, 'total_amount'], 0);

  const isProcessing = isLoading || isSaving;
  const isOPMDisabled = isProcessing || !opmId || opmAmount <= 0;
  const isGiftCardDisabled = isProcessing || !giftCardId || giftCardAmount <= 0;
  const isOPMChecked = selected === ReturnPaymentTypes.OriginalPaymentMethod.key && opmAmount > 0;
  const isGiftCardChecked = selected === ReturnPaymentTypes.GiftCard.key && giftCardAmount > 0;

  const onOriginalPaymentMethodSelect = () => {
    if (isOPMDisabled) return;
    const id = get(options, [ReturnPaymentTypes.OriginalPaymentMethod.key, 'id'], '');
    onSelectRefundMethod(id);
  };

  const onGiftCardSelect = () => {
    if (isGiftCardDisabled) return;
    const id = get(options, [ReturnPaymentTypes.GiftCard.key, 'id'], '');
    onSelectRefundMethod(id);
  };

  return (
    <FlexColumn gap={Gap.Space8}>
      <RadioCheckListItem
        className={style.option}
        isChecked={isOPMChecked}
        isDisabled={isOPMDisabled}
        name={RADIO_INPUT_NAME}
        onChecked={onOriginalPaymentMethodSelect}
        value={ReturnPaymentTypes.OriginalPaymentMethod.key}
      >
        <Text textType='Paragraph' value={ReturnPaymentTypes.OriginalPaymentMethod.translation} />
      </RadioCheckListItem>
      <RadioCheckListItem
        className={style.option}
        isChecked={isGiftCardChecked}
        isDisabled={isGiftCardDisabled}
        name={RADIO_INPUT_NAME}
        onChecked={onGiftCardSelect}
        value={ReturnPaymentTypes.GiftCard.key}
      >
        <Text textType='Paragraph' value={ReturnPaymentTypes.GiftCard.translation} />
      </RadioCheckListItem>
    </FlexColumn>
  );
}
